import CAIconComponent from '@ds/components/shared/CAIconComponent'
import { defineComponent } from 'vue'

/**
 * The `CACloseButton` component is used to display a close button.
 * @component CACloseButton
 *
 * @prop {string} [label=''] - The label for the close button.
 * @prop {string} [svgClass='svg-component'] - The class for the SVG icon.
 *
 * @emit close - Emits when the close button is clicked.
 */
export default defineComponent({
	name: 'CACloseButton',

	props: {
		/**
		 * The label for the close button.
		 * @default ''
		 * @type {string}
		 */
		label: { default: '', type: String },
		/**
		 * The class for the SVG icon.
		 * @default 'svg-component'
		 * @type {string}
		 */
		svgClass: { default: 'svg-component', type: String },
	},

	emits: ['close'],

	methods: {
		handleClick() {
			this.$emit('close')
		},
	},

	render() {
		return (
			<div class="ca-close-button-wrapper">
				<button
					class="ca-close-button"
					data-test="ca-close-button"
					type="button"
					onClick={this.handleClick}
				>
					<span class="absolute -inset-1.5" />
					<span class="sr-only" data-test="ca-close-button-label">
						{this.label || 'close modal'}
					</span>

					<CAIconComponent class={this.svgClass} icon="SVGClose" />
				</button>
			</div>
		)
	},
})
